import { render, staticRenderFns } from "./tongueRoundL.vue?vue&type=template&id=f5869dc4&"
import script from "./tongueRoundL.vue?vue&type=script&lang=js&"
export * from "./tongueRoundL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports